import { Box, Card, Typography, useTheme } from "@mui/material";

export default function Certificates() {
    const theme = useTheme();

    return (
        <Box sx={{ p: 3, background: theme.palette.background.default }}>
            <Card
                sx={{
                    width: "100%",
                    height:"85vh",
                    background: theme.palette.background.paper,
                    borderRadius: "12px",
                    p: 4,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: 300,
                }}
            >
                <Box textAlign="center">
                    {/* Illustration */}
                    <Box
                        component="img"
                        src="/nocertificates.png"
                        alt="No Achievements"
                        sx={{
                            width: 280,
                            height: 254,
                            mx: "auto",
                            display: "block",
                            objectFit: "contain",
                        }}
                    />

                    {/* Title */}
                    <Typography
                        sx={{
                            fontSize: 16,
                            fontWeight: 500,
                            color: theme.palette.text.primary,
                            mt: 1,
                        }}
                    >
                        No accomplishments yet
                    </Typography>

                    {/* Subtitle */}
                    <Typography
                        sx={{
                            fontSize: 14,
                            color: theme.palette.text.secondary,
                            mt: 0.5,
                        }}
                    >
                        Complete courses to unlock your achievements!
                    </Typography>
                </Box>
            </Card>

        </Box>
    )
}
